import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import { Box } from '@mui/material';
import { Analytics } from '@vercel/analytics/react';
import Home from './pages/Home';
import BCBAROICalculator from './pages/BCBAROICalculator';
import BCBAGoalGeneratorPage from './pages/BCBAGoalGeneratorPage';
import TaskAnalysisBuilderPage from './pages/TaskAnalysisBuilderPage';
import SessionNoteSummarizerPage from './pages/SessionNoteSummarizerPage';
import DataCollectionHelperPage from './pages/DataCollectionHelperPage';
import BCBAUtilizationCalculatorPage from './pages/BCBAUtilizationCalculatorPage';
import GoalWritingAssistantPage from './pages/GoalWritingAssistantPage';
import ProgressNoteTemplateCreatorPage from './pages/ProgressNoteTemplateCreatorPage';
import PricingCalculatorPage from './pages/PricingCalculatorPage';
import InterventionStrategyGeneratorPage from './pages/InterventionStrategyGeneratorPage';
import BIPTemplateGeneratorPage from './pages/BIPTemplateGeneratorPage';


// In your Routes component:

// In your Routes component:


const theme = createTheme({
  palette: {
    primary: {
      main: '#3f51b5', // Indigo
      dark: '#303f9f'
    },
    secondary: {
      main: '#3f51b5', // Indigo
    },
    background: {
      default: '#e8eaf6', // Light Indigo
    },
  },
   components: {
    MuiPaper: {
      defaultProps: {
        elevation: 0,
      },
    },
  },

});

function App() {
  return (
    <ThemeProvider theme={theme}>
      <Router>
        <Box sx={{ backgroundColor: 'background.default', minHeight: '100vh', display: 'flex', alignItems: 'center' }}>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/bcba-roi-calculator" element={<BCBAROICalculator />} />
            <Route path="/bcba-goal-generator" element={<BCBAGoalGeneratorPage />} />
            <Route path="/task-analysis-builder" element={<TaskAnalysisBuilderPage />} />
            <Route path="/session-note-summarizer" element={<SessionNoteSummarizerPage />} />
            <Route path="/data-collection-helper" element={<DataCollectionHelperPage />} />
            <Route path="/bcba-utilization-calculator" element={<BCBAUtilizationCalculatorPage />} />
            <Route path="/goal-writing-assistant" element={<GoalWritingAssistantPage />} />
            <Route path="/progress-note-template-creator" element={<ProgressNoteTemplateCreatorPage />} />
            <Route path="/pricing-calculator" element={<PricingCalculatorPage />} />
            <Route path="/intervention-strategy-generator" element={<InterventionStrategyGeneratorPage />} />
            <Route path="/bip-template-generator" element={<BIPTemplateGeneratorPage />} />


          </Routes>
        </Box>
      </Router>
      <Analytics />
    </ThemeProvider>
  );
}

export default App;